import { apiService } from '../services/apiService';

const GAMES_ENDPOINT = '/api/games';

export async function listGames(params = {}) {
  // enforce sensible defaults and ensure production requests ask for more items
  const requestParams = {
    page: params.page || 1,
    limit: 200,
    ...params
  };
  const response = await apiService.get(GAMES_ENDPOINT, { params: requestParams });
  return response.data;
}

export async function fetchCategories() {
  const response = await apiService.get(`${GAMES_ENDPOINT}/categories`);
  return response.data;
}

export async function getGame(gameId) {
  if (!gameId) throw new Error('Game ID is required');
  const response = await apiService.get(`${GAMES_ENDPOINT}/${gameId}`);
  return response.data;
}

export async function createGame(formData) {
  const response = await apiService.post(GAMES_ENDPOINT, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
}

export async function updateGame(gameId, formData) {
  if (!gameId) throw new Error('Game ID is required');
  const response = await apiService.put(`${GAMES_ENDPOINT}/${gameId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
}

export async function deleteGame(gameId) {
  if (!gameId) throw new Error('Game ID is required');
  const response = await apiService.delete(`${GAMES_ENDPOINT}/${gameId}`);
  return response.data;
}
